import dayjs from "dayjs";
import durationPlugin from "dayjs/plugin/duration";
import { ALLOWED_CHARACTERS } from "./constants";
dayjs.extend(durationPlugin);

// eslint-disable-next-line import/prefer-default-export
export function format(duration) {
  if (!duration) {
    return null;
  }
  var validatedDuration = duration === null || duration === void 0 ? void 0 : duration.toString().replace(ALLOWED_CHARACTERS, "");
  var durationInt = parseInt(validatedDuration, 10);
  if (!durationInt) {
    durationInt = 0;
  }
  var rescaledDuration = dayjs.duration(durationInt, "minutes");
  var totalHours = Math.floor(rescaledDuration.asHours());
  var leftoverMin = rescaledDuration.minutes();
  var formattedDuration = "";
  if (totalHours) formattedDuration += "".concat(totalHours, "h ");
  if (leftoverMin) formattedDuration += "".concat(leftoverMin, "m");
  return formattedDuration;
}